import {useEffect, useState} from "react";

interface DispatchedValueHook {
    value: string;
    setValue: (str: string) => void;
    processing: boolean;
    dispatchValue: () => void;
}

export function useDispatchedValue(dispatch: (x: string) => void): DispatchedValueHook {

    const [value, setValue] = useState<string>("");
    const [initiliased, setInitialised] = useState<boolean>(false);
    const [processing, setProcessing] = useState<boolean>(false);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (!value && !initiliased) {
            return;
        }

        setInitialised(true);
        setProcessing(true)
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                dispatchValue()
            }, 1000)
        );
    }, [value]);

    const dispatchValue = () => {
        if (timer) {
            clearTimeout(timer)
        }

        dispatch(value)
        setProcessing(false)
    }

    return {
        value,
        setValue,
        processing,
        dispatchValue
    };
}
